var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 0H14V16H16V0Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2 0H0V16H2V0Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9 0H7V4H9V0Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9 6H7V10H9V6Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9 12H7V16H9V12Z",
    fill: "#D1D1D1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoad);
export default __webpack_public_path__ + "static/media/road.d325ec6021bc9a5b671ca2ec015435b2.svg";
export { ForwardRef as ReactComponent };